import { takeEvery, takeLatest, fork, take } from 'redux-saga/effects';
import {
  ADD_NOTE_REQUEST,
  AWAITING_APPROVAL_REQUEST,
  CANCEL_RETURN_REQUEST,
  CLIENT_APPROVE_REQUEST,
  EXCEPTIONS_ACTION_REQUEST,
  FETCH_ACTIVITY_LOGS_REQUEST,
  FETCH_DATA_PAGE_REQUEST,
  FETCH_EXCEL_FILE_REQUEST,
  FETCH_RUN_DATA_REQUEST,
  FETCH_TRANSACTION_FILTERS,
  FETCH_TRANSACTION_ATTACHMENT_REQUEST,
  FETCH_METADATA_ATTACHMENTS_REQUEST,
  FETCH_VAT_LOGS_REQUEST,
  FETCH_VIEW_RUN_DATA_REQUEST,
  GENERATE_REPORT_REQUEST,
  INTERNALLY_APPROVE_REQUEST,
  LOAD_RECON_REQUEST,
  LOAD_REPORT_REQUEST,
  LOAD_REPORT_TOTALS_REQUEST,
  LOCK_RETURN_REQUEST,
  MANUAL_JOURNAL_POST_REQUEST,
  NOT_APPROVE_REQUEST,
  SAVE_RETURN_REQUEST,
  SEND_CLIENT_APPROVAL_REQUEST,
  SUBMIT_RETURN_REQUEST,
  SUBMIT_HMRC_RETURN_REQUEST,
  UPDATE_ACTIVITY_ROLE_REQUEST,
  UPDATE_REPORT_FIELDS_REQUEST,
  UPLOAD_TRANSACTION_ATTACHMENT_REQUEST,
  EXPORT_TO_CSV_REQUEST,
  EXPORT_TO_EXCEL_REQUEST,
  TOUCH_REPORT,
  REFRESH_REPORT_REQUEST,
} from '../constants';
import { fetchVatLogsSaga } from './fetchVatLogsSaga';
import { fetchRunDataSaga, watchFetchRunDataSaga } from './fetchRunDataSaga';
import { generateReportSaga, refreshReportSaga } from './generateReportSaga';
import { loadReconSaga } from './loadReconSaga';
import { saveReturnSaga } from './saveReturnSaga';
import { fetchViewRunDataSaga } from './fetchViewRunDataSaga';
import { loadReportSaga } from './loadReportSaga';
import { loadReportTotalsSaga } from './loadReportTotalsSaga';
import { cancelReturnSaga } from './cancelReturnSaga';
import { updateActivityRoleSaga } from './updateActivityRoleSaga';
import { addNoteSaga } from './addNoteSaga';
import { fetchActivityLogsSaga } from './fetchActivityLogsSaga';
import { awaitingApprovalSaga } from './awaitingApprovalSaga';
import { internallyApproveSaga } from './internallyApproveSaga';
import { sendClientApprovalSaga } from './sendClientApprovalSaga';
import { clientApproveSaga } from './clientApproveSaga';
import { notApproveSaga } from './notApprovedSaga';
import { submitReturnSaga } from './submitReturnSaga';
import { submitHmrcReturnSaga } from './submitHmrcReturnSaga';
import { fetchExcelFileSaga } from './fetchExcelFileSaga';
import { saveExceptionsActionSaga } from './saveExceptionsActions';
import { manualJournalPostSaga } from './manualJournalPostSaga';
import { fetchDataJournalsPageSaga } from './fetchDataPageSaga';
import { fetchTransactionsFiltersSaga } from './fetchTransactionsFiltersSaga';
import { fetchTransactionAttachment } from './fetchTransactionAttachmentSaga';
import { fetchMetadataAttachmentsSaga } from './fetchMetadataAttachmentsSaga';
import { uploadTransactionAttachmentSaga } from './uploadTransactionAttachmentSaga';
import { exportToCsvRequestSaga } from './exportToCsvSaga';
import { exportToExcelRequestSaga } from './exportToExcelRequestSaga';
import { watchGenerateReportSaga } from './generateReportSaga';
import { watchLoadReportSaga } from './loadReportSaga';
import { lockReturnSaga } from './lockReturnSaga';
import { updateReportFieldsSaga } from './updateReportFieldsSaga';
import { touchReportSaga } from './touchReportSaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* vatSaga() {
  yield takeLatest(FETCH_VAT_LOGS_REQUEST, fetchVatLogsSaga);
  yield fork(watchFetchRunDataSaga);
  yield takeLatest(FETCH_VIEW_RUN_DATA_REQUEST, fetchViewRunDataSaga);
  yield fork(watchGenerateReportSaga);
  yield fork(watchLoadReportSaga);
  yield takeLatest(LOAD_REPORT_TOTALS_REQUEST, loadReportTotalsSaga);
  yield takeLatest(LOAD_RECON_REQUEST, loadReconSaga);
  yield takeLatest(SAVE_RETURN_REQUEST, saveReturnSaga);
  yield takeLatest(UPDATE_REPORT_FIELDS_REQUEST, updateReportFieldsSaga);
  yield takeLatest(CANCEL_RETURN_REQUEST, cancelReturnSaga);
  yield takeLatest(UPDATE_ACTIVITY_ROLE_REQUEST, updateActivityRoleSaga);
  yield takeLatest(ADD_NOTE_REQUEST, addNoteSaga);
  yield takeLatest(FETCH_ACTIVITY_LOGS_REQUEST, fetchActivityLogsSaga);
  yield takeLatest(AWAITING_APPROVAL_REQUEST, awaitingApprovalSaga);
  yield takeLatest(INTERNALLY_APPROVE_REQUEST, internallyApproveSaga);
  yield takeLatest(SEND_CLIENT_APPROVAL_REQUEST, sendClientApprovalSaga);
  yield takeLatest(CLIENT_APPROVE_REQUEST, clientApproveSaga);
  yield takeLatest(NOT_APPROVE_REQUEST, notApproveSaga);
  yield takeLatest(LOCK_RETURN_REQUEST, lockReturnSaga);
  yield takeLatest(SUBMIT_RETURN_REQUEST, submitReturnSaga);
  yield takeLatest(SUBMIT_HMRC_RETURN_REQUEST, submitHmrcReturnSaga);
  yield takeLatest(FETCH_EXCEL_FILE_REQUEST, fetchExcelFileSaga);
  yield takeLatest(EXCEPTIONS_ACTION_REQUEST, saveExceptionsActionSaga);
  yield takeLatest(MANUAL_JOURNAL_POST_REQUEST, manualJournalPostSaga);
  yield takeLatest(FETCH_DATA_PAGE_REQUEST, fetchDataJournalsPageSaga);
  yield takeLatest(FETCH_TRANSACTION_FILTERS, fetchTransactionsFiltersSaga);
  yield takeLatest(
    FETCH_TRANSACTION_ATTACHMENT_REQUEST,
    fetchTransactionAttachment
  );
  yield takeLatest(
    FETCH_METADATA_ATTACHMENTS_REQUEST,
    fetchMetadataAttachmentsSaga
  );
  yield takeLatest(
    UPLOAD_TRANSACTION_ATTACHMENT_REQUEST,
    uploadTransactionAttachmentSaga
  );
  yield takeLatest(EXPORT_TO_CSV_REQUEST, exportToCsvRequestSaga);
  yield takeLatest(EXPORT_TO_EXCEL_REQUEST, exportToExcelRequestSaga);
  yield takeLatest(TOUCH_REPORT, touchReportSaga);
  yield takeLatest(REFRESH_REPORT_REQUEST, refreshReportSaga);
}
